var _a;
import { drawer, drawerNested, content, drawerHeader, drawerHeaderNested, overlay, overlayOpenBody, subHeader, } from '../styles/legacy';
import { drawer as drawerCitrus2022, drawerNested as drawerNestedCitrus2022, content as contentCitrus2022, drawerHeader as drawerHeaderCitrus2022, drawerHeaderNested as drawerHeaderNestedCitrus2022, overlay as overlayCitrus2022, subHeader as subHeaderCitrus2022, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
import { injectGlobal } from 'emotion';
export var drawerOverlayOpenBodyIdentifier = 'pcty-fa915ce-overlay-open';
var globalRules = (_a = {},
    _a[".".concat(drawerOverlayOpenBodyIdentifier)] = overlayOpenBody,
    _a);
injectGlobal(globalRules);
export var Drawer = citrusStyled.div('drawer', { legacy: drawer, citrus2022: drawerCitrus2022 });
export var DrawerNested = citrusStyled.div('drawerNested', {
    legacy: drawerNested,
    citrus2022: drawerNestedCitrus2022,
});
export var Content = citrusStyled.div('content', { legacy: content, citrus2022: contentCitrus2022 });
export var ContentInner = citrusStyled.div('N/A', null);
export var DrawerHeader = citrusStyled.div('drawerHeader', {
    legacy: drawerHeader,
    citrus2022: drawerHeaderCitrus2022,
});
export var DrawerHeaderNested = citrusStyled.div('drawerHeader', {
    legacy: drawerHeaderNested,
    citrus2022: drawerHeaderNestedCitrus2022,
});
export var Overlay = citrusStyled.div('overlay', { legacy: overlay, citrus2022: overlayCitrus2022 });
export var Subheader = citrusStyled.div('subHeader', { legacy: subHeader, citrus2022: subHeaderCitrus2022 });
export var Styled = {
    Drawer: Drawer,
    DrawerNested: DrawerNested,
    Overlay: Overlay,
    DrawerHeader: DrawerHeader,
    DrawerHeaderNested: DrawerHeaderNested,
    Subheader: Subheader,
    Content: Content,
    ContentInner: ContentInner,
};
